import { PiggyBank } from 'lucide-react';
import { NumPad } from '../../../components';
import { StepLayout } from '../StepLayout';
import type { OnboardingDraft } from '../types';

type Props = {
  draft: OnboardingDraft;
  setDraft: (patch: Partial<OnboardingDraft>) => void;
  onContinue: () => void;
};

/**
 * Conditional step shown only when the user picked Pay Yourself First.
 * Hourly take-home drives the daily / weekly / monthly / yearly savings
 * projections on Today and Plan, so without it the model has nothing to
 * show. Better to ask now than send them hunting in Settings.
 */
export function HourlyRateStep({ draft, setDraft, onContinue }: Props) {
  return (
    <StepLayout
      icon={<PiggyBank size={28} strokeWidth={1.5} />}
      title="What's your hourly take-home?"
      description="Pay Yourself First works by saving an hour of pay each day. We use this to project your daily, weekly, monthly, and yearly savings."
      footer={null}
    >
      <NumPad
        initialValue={draft.hourlyRate ?? 0}
        onChange={(v) => setDraft({ hourlyRate: v })}
        onDone={(v) => {
          setDraft({ hourlyRate: v });
          if (v > 0) onContinue();
        }}
        doneLabel="Get started"
      />
    </StepLayout>
  );
}
